/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState, useContext, useCallback } from 'react';
import HomeLayout from '../Layouts/homeLayout';
import { PayloadContext } from '../../context';
import { fullname } from '../helpers';
import { toast } from 'react-toastify';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
// import Cropper from 'react-easy-crop';
import ImageCroper from '../common/imageCrop';
// import Compressor from 'compressorjs';

const API_URL = 'https://api.konx.biz/';
// const API_URL = 'http://localhost:4040/';

function WatchVideos()
{

	return (
		<div className='flexCol baseBg pdngXS'>
			<div className='flexCol alignCntr baseBg pdngLG dashboardCntnr'>
				<div className='flexCol alignCntr pdngBMD'>
					<video className='ftr-col-content' controls poster='https://konx.biz/images/why-konx-tn.jpg'>
						<source src='https://konx.biz/video/why-konx.mp4' />
					</video>
				</div>
				<p>&nbsp;</p>
				<div className='flexCol alignCntr pdngBMD'>
					<video className='ftr-col-content' controls poster='https://konx.biz/images/how-to-start-a-mtg-tn.jpg'>
						<source src='https://konx.biz/video/how-to-use-konx.mp4' />
					</video>
				</div>
			</div>
			<p>&nbsp;</p>
			<div className='flexCol alignCntr pdngBMD'>
				<video className='ftr-col-content' controls poster='https://konx.biz/images/mv-tn.jpg'>
					<source src='https://konx.biz/video/mv.mp4' />
				</video>
			</div>
			<p>&nbsp;</p>
			<div className='flexCol alignCntr pdngBMD'>
				<video className='ftr-col-content' controls poster='https://konx.biz/images/iov-tn.jpg'>
					<source src='https://konx.biz/video/iov.mp4' />
				</video>
			</div>
			<p>&nbsp;</p>
			<div className='flexCol alignCntr pdngBMD'>
				<video className='ftr-col-content' controls poster='https://konx.biz/images/bov-tn.jpg'>
					<source src='https://konx.biz/video/bov.mp4' />
				</video>
			</div>
		</div>
	);
}

export default HomeLayout(WatchVideos);
